import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m 21.1066,9.25735 c 0.3905,-0.39053 0.3905,-1.02369 0,-1.41422 L 16.1568,2.89339 c -0.3905,-0.39053 -1.0237,-0.39053 -1.4142,0 L 4.48024,13.1558 c -0.12068,0.1207 -0.20826,0.27 -0.25478,0.4336 -0.00457,0.0161 -0.00874,0.0323 -0.0125,0.0486 l -1.48493,6.4347 c -0.16617,0.7201 0.47918,1.3654 1.19925,1.1992 L 10.362,19.787 c 0.0163,-0.0038 0.0325,-0.0079 0.0485,-0.0125 0.1637,-0.0465 0.313,-0.1341 0.4337,-0.2548 z M 15.4497,5.01471 18.9853,8.55024 10.5,17.0355 6.96445,13.5 Z M 5.03659,18.9634 5.89212,15.2561 8.74389,18.1079 Z"
  }));
});
var ActionsEdit = AbstractIcon.withComponent(Icon);
ActionsEdit.displayName = 'ActionsEdit';
export default ActionsEdit;